import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "inProp", "transitionType", "transitionTimeout", "customTransition", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "appear", "mountOnEnter", "unmountOnExit", "enter", "exit", "isFullHeight", "isFullWidth"];
import React from 'react';
import { Transition } from 'react-transition-group';
import Item from './Item';
import transitionOptionStyles from '../../styles/transitionOptionStyles';
import helpersPropTypes from '../../prop-types/helpersPropTypes';

var TransitionItem = function TransitionItem(_ref) {
  var children = _ref.children,
      inProp = _ref.inProp,
      transitionType = _ref.transitionType,
      transitionTimeout = _ref.transitionTimeout,
      customTransition = _ref.customTransition,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      onExited = _ref.onExited,
      appear = _ref.appear,
      mountOnEnter = _ref.mountOnEnter,
      unmountOnExit = _ref.unmountOnExit,
      enter = _ref.enter,
      exit = _ref.exit,
      isFullHeight = _ref.isFullHeight,
      isFullWidth = _ref.isFullWidth,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var transitionTypeStyles = function transitionTypeStyles(transitionOption) {
    var _ref2 = customTransition ? {} : transitionOptionStyles.find(function (styleOption) {
      return styleOption.type === transitionOption;
    }),
        _ref2$initial = _ref2.initial,
        initial = _ref2$initial === void 0 ? {} : _ref2$initial,
        _ref2$transition = _ref2.transition,
        transition = _ref2$transition === void 0 ? {} : _ref2$transition,
        _ref2$timeout = _ref2.timeout,
        timeout = _ref2$timeout === void 0 ? 0 : _ref2$timeout;

    return {
      initial: initial,
      transition: transition,
      timeout: timeout
    };
  };

  var renderStyle = customTransition || transitionTypeStyles(transitionType);
  var renderTimeout = transitionTimeout || transitionTypeStyles(transitionType).timeout;
  return /*#__PURE__*/React.createElement(Transition, Object.assign({
    in: inProp,
    timeout: renderTimeout,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    appear: appear,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    enter: enter,
    exit: exit
  }, props), function (state) {
    return /*#__PURE__*/React.createElement(Item, {
      isFullHeight: isFullHeight,
      isFullWidth: isFullWidth,
      style: Object.assign({}, renderStyle.initial, renderStyle.transition[state])
    }, children);
  });
};

TransitionItem.defaultProps = {
  inProp: false,
  transitionType: 'fadeInFadeOut',
  transitionTimeout: null,
  customTransition: null,
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {},
  appear: false,
  mountOnEnter: false,
  unmountOnExit: false,
  enter: true,
  exit: true,
  isFullHeight: false,
  isFullWidth: true
};
export default TransitionItem;